import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collections: {},
  lowStockProducts: [],
  formFilters: {categories: [], types: []},
  requesting: true,
  lowStockLoading: false,
  filtersLoading: false,

  isDeleted: false,
  deleting: false,

  isQuantityUpdated: false,
  updatingQuantity: false,

  errors: {}
};

const Slice = createSlice({
  name: '@admin/Inventory|List',
  initialState,
  reducers: {
    
    getList: (state) => {
        state.collections = {};
        state.requesting = true;
    },
    getListSuccess: (state, action) => {
        const { payload } = action;
        state.collections = payload;
        state.requesting = false;
    },
    getListFailed: (state, action) => {
        state.errors = action.payload;
        state.requesting = false;
    },

  // ----- LOW STOCK PRODUCTS -----
    getLowStockProducts: (state) => {
        state.lowStockProducts = [];
        state.lowStockLoading = true;
    },
    getLowStockProductsSuccess: (state, action) => {
        const { payload } = action;
        state.lowStockProducts = payload;
        state.lowStockLoading = false;
    },
    getLowStockProductsFailed: (state, action) => {
        state.errors = action.payload;
        state.lowStockLoading = false;
    },

  // ----- FORM FILTERS -----
    getFormFilters: (state) => {
        state.formFilters = {categories: [], types: []};
        state.filtersLoading = true;
    },
    getFormFiltersSuccess: (state, action) => {
        const { payload } = action;
        state.formFilters = payload;
        state.filtersLoading = false;
    },
    getFormFiltersFailed: (state, action) => {
        state.errors = action.payload;
        state.filtersLoading = false;
    },

  // ----- DELETE -----
    toDelete: (state) => {
        state.isDeleted = false;
        state.deleting = true;
    },
    toDeleteSuccess: (state) => {
        state.isDeleted = true;
        state.deleting = false;
    },
    toDeleteFailed: (state, action) => {
        state.errors = action.payload;
        state.deleting  = false;
        state.isDeleted = false;
    },

  // ----- UPDATE QUANTITY -----
    updateQuantity: (state) => {
        state.isQuantityUpdated = false;
        state.updatingQuantity = true;
    },
    updateQuantitySuccess: (state) => {
        state.isQuantityUpdated = true;
        state.updatingQuantity = false;
    },
    updateQuantityFailed: (state, action) => {
        state.errors = action.payload;
        state.updatingQuantity = false;
        state.isQuantityUpdated = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminInventoryProductsListReducers: Slice.reducer,
}
export default Reducers;